export default __webpack_public_path__ + "static/media/summerchallenge14.59daefae.jpg";